<template>
	<div v-if="show" :class="slideInClass">
		<header class="titled">
			<div>
				<h2>{{ jobProfile.name || jobProfile.info }}</h2>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="onClose">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<Matching
				:job-id="job.id"
				:job-profile-id="jobProfile.id"
				@loaded="loadedMatching = true"
			/>
		</main>
		<footer v-if="withActions && loadedMatching">
			<div class="job-list-item-actions on-white-background">
				<template v-if="!exclusion">
					<Favorite
						:job-profile-id="jobProfile.id"
						:job-id="job.id"
						:initial-favored="favored"
						type="application"
						@change="favoriteChanged"
					/>
					<Notice
						:job-profile-id="jobProfile.id"
						:notice="notice"
						type="application"
						@change="noticeChanged"
					/>
				</template>
				<Exclusion
					:job-profile-item="jobProfile"
					:job-id="job.id"
					:exclusion="exclusion"
					@change="exclusionChanged"
				/>
			</div>
			<div class="contact-button-container">
				<ContactJobProfile
					v-if="isPublished && !exclusion"
					:job-id="job.id"
					:job-profile-id="jobProfile.id"
					:job-profile-name="jobProfile.name"
					:initial-in-contacting="hasOngoingConversation"
					@contacted="contactSuccessful"
				/>
			</div>
		</footer>
	</div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import Matching from "@/vue/application/job/matching/Matching";
import {getClasses} from "@/helper/layout/Fan";
import Exclusion from "@/vue/application/job/exclusion/Exclusion";
import {OPEN_FAN_KEY} from "@/store/job/matching";
import ContactJobProfile from "@/vue/communication/ContactJobProfile";
import {PUBLISHED} from "@/helper/job/Status";
import Favorite from "@/vue/customer/job-profile/applicant/Favorite.vue";
import Notice from "@/vue/job-result/notice/Notice.vue";

export default {

	components: {
		Notice,
		Favorite,
		Exclusion,
		ContactJobProfile,
		Icon,
		Matching,
	},

	data ()
	{
		return {
			loadedMatching: false,
		};
	},

	computed: {
		...mapState('layout', ['fanLevelClasses']),
		...mapState('job/matching', [
			'show',
			'job',
			'jobProfile',
			'hasOngoingConversation',
			'favored',
			'notice',
			'exclusion',
			'withActions',
			'onContacted',
			'onFavoriteChange',
			'onNoticeChange',
			'onExclusionChange'
		]),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['job-matching-fan'],
			})
		},
		isPublished ()
		{
			return this.job.status === PUBLISHED;
		}
	},

	methods: {
		...mapActions('job/matching', [
			'close'
		]),
		...mapMutations('job/matching', [
			'setFavored',
			'setNotice',
			'setExclusion'
		]),
		contactSuccessful ()
		{
			if (this.onContacted)
			{
				this.onContacted({
					job: this.job,
					jobProfile: this.jobProfile
				});
			}
		},
		favoriteChanged (favored)
		{
			this.setFavored(favored);

			if (this.onFavoriteChange)
			{
				this.onFavoriteChange(favored);
			}
		},
		noticeChanged (notice)
		{
			this.setNotice(notice);

			if (this.onNoticeChange)
			{
				this.onNoticeChange(notice);
			}
		},
		exclusionChanged (exclusion)
		{
			this.setExclusion(exclusion);

			if (this.onExclusionChange)
			{
				this.onExclusionChange(exclusion);
			}
		},
		onClose ()
		{
			this.loadedMatching = false;

			this.close();
		}
	}
}
</script>
